import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import { reiRoutes } from './sofiaReiRoutes'

// export default new Router({
const router = new Router({
  mode: process.env.VUE_APP_SOFIA_DESKTOP ? 'hash' : 'history',
  base: process.env.BASE_URL,
  routes: [
    // ...sofiaRoutes,
    // ...esinoregRoutes,
    ...reiRoutes,
    {
      path: '*',
      component: () => import('../views/PageNotFound.vue')
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})

export default router
